import React, { useState, useEffect } from 'react';

import Link from 'next/link';

import { Book1, Cup, MedalStar } from 'iconsax-react';

import gmpImage from 'assets/images/pages/homepage/career-paths/GMP_Basics_Career_Path (1).jpg';
import pvImage from 'assets/images/pages/homepage/career-paths/PV_career_path_image.png';
import qaImage from 'assets/images/pages/homepage/career-paths/Quality_Assurance_Specialist.jpg';

import classes from './CareerPathBuilder.module.scss';

const CARDS = [
    {
        id: 'gmp-basics',
        title: 'GMP Basics',
        courses: 6,
        assessments: 1,
        level: 'Beginner',
        href: '/career-path/1/gmp-basics',
        image: gmpImage,
    },
    {
        id: 'quality-assurance-specialist',
        title: 'Quality Assurance Specialist',
        courses: 7,
        assessments: 1,
        level: 'Intermediate',
        href: '/career-path/2/quality-assurance-specialist',
        image: qaImage,
    },
    {
        id: 'pharmacovigilance-specialist',
        title: 'Pharmacovigilance Specialist (Drug Safety)',
        courses: 5,
        assessments: 1,
        level: 'Intermediate',
        href: '/career-path/6/pharmacovigilance-specialist-drug-safety',
        image: pvImage,
    },
];

const INCLUDED = [
    { id: 'courses', Icon: Book1, text: '10-12 expert-curated courses per path' },
    { id: 'assessments', Icon: Cup, text: 'Measure your skills with Assessments' },
    { id: 'certificate', Icon: MedalStar, text: 'Earn trusted certification' },
];

const ROTATE_MS = 3500;

const VIEW_ALL_HREF = '/career-path';

const CareerPathBuilder = () => {
    const [active, setActive] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setActive((prev) => (prev + 1) % CARDS.length);
        }, ROTATE_MS);
        return () => clearInterval(timer);
    }, []);

    return (
        <section className={classes['cpb']}>
            <div className='container'>
                <div className={classes['cpb__inner']}>
                    <a href={VIEW_ALL_HREF} className={classes['cpb__view-all']}>
                        View All Career paths
                    </a>

                    <div className={classes['cpb__grid']}>
                        <div className={classes['cpb__content']}>
                            <h2>Build Your Personalized Pharma Career Path and Progress with Confidence</h2>
                            <p>
                                Follow 5–7 expert-curated courses that guide you through a structured learning journey,
                                helping you gain the expertise needed to succeed in a specific pharma career path.
                            </p>

                            <h4 className={classes['cpb__list-title']}>Included in career paths:</h4>
                            <ul className={classes['cpb__list']}>
                                {INCLUDED.map(({ id, Icon, text }) => (
                                    <li key={id}>
                                        <span className={classes['cpb__list-icon']}>
                                            <Icon size={22} color='#18BBA8' variant='Linear' />
                                        </span>
                                        <span>{text}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        <div className={classes['cpb__carousel']} aria-label='Career path courses'>
                            {CARDS.map((card, index) => {
                                const offset = (index - active + CARDS.length) % CARDS.length;
                                return (
                                    <Link
                                        key={card.id}
                                        href={card.href}
                                        className={`${classes['cpb__card']} ${classes[`cpb__card--pos${offset}`]}`}
                                        aria-hidden={offset !== 0}
                                        tabIndex={offset === 0 ? 0 : -1}
                                    >
                                        <div className={classes['cpb__card-media']}>
                                            {card.image ? (
                                                <img src={card.image.src} alt={card.title} />
                                            ) : (
                                                <span className={classes['cpb__card-placeholder']} />
                                            )}
                                        </div>
                                        <div className={classes['cpb__card-body']}>
                                            <h3>{card.title}</h3>
                                            <div className={classes['cpb__card-meta']}>
                                                <div className={classes['cpb__card-stats']}>
                                                    <span>{card.courses} Courses</span>
                                                    <span>{card.assessments} Assessment</span>
                                                </div>
                                                <span className={classes['cpb__level']}>{card.level}</span>
                                            </div>
                                        </div>
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CareerPathBuilder;
